import { render } from "./article-plat-set.vue?vue&type=template&id=effdff02&scoped=true&ts=true"
import script from "./article-plat-set.vue?vue&type=script&lang=ts"
export * from "./article-plat-set.vue?vue&type=script&lang=ts"

import "./article-plat-set.vue?vue&type=style&index=0&id=effdff02&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-effdff02"]])

export default __exports__